function isLoopbackHost(hostname) {
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "[::1]";
}

function isPrivateLanHost(hostname) {
  if (!hostname) return false;
  if (hostname.endsWith(".local")) return true;
  if (/^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true;
  if (/^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true;
  if (/^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true;
  return false;
}

export function getWebSocketUrl(path) {
  if (typeof window === "undefined") return null;
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const { protocol, hostname, host, port } = window.location;
  const wsProtocol = protocol === "https:" ? "wss:" : "ws:";

  const envWs = process.env.REACT_APP_AETERNA_WS_URL;
  if (typeof envWs === "string" && envWs.trim()) {
    const trimmed = envWs.trim();
    if (trimmed.includes("://")) {
      return trimmed;
    }
    return `${wsProtocol}//${trimmed}${normalizedPath}`;
  }

  const envApi = process.env.REACT_APP_AETERNA_API_URL;
  if (typeof envApi === "string" && envApi.trim()) {
    const apiBase = envApi.trim().replace(/\/$/, "");
    const apiWsProtocol = apiBase.startsWith("https:") ? "wss:" : "ws:";
    const apiHost = apiBase.replace(/^https?:\/\//, "");
    return `${apiWsProtocol}//${apiHost}${normalizedPath}`;
  }

  if (isLoopbackHost(hostname) || isPrivateLanHost(hostname) || port === "3000") {
    if (protocol === "https:") {
      return `${wsProtocol}//${host}${normalizedPath}`;
    }
    return `ws://${hostname}:5000${normalizedPath}`;
  }

  return `${wsProtocol}//${host}${normalizedPath}`;
}
